// Maps raw gateway errors stored on late-payment rows
// (e.g. "Error code: EXPIRED_CARD . Error message:") to
// user-friendly translation keys. Never show raw codes to donors.
const REASONS = {
  EXPIRED_CARD: 'Your card has expired. Please pay again using a valid card.',
  INSUFFICIENT_FUNDS: 'The payment was declined due to insufficient funds.',
  DECLINED: 'The payment was declined by your bank.',
  DECLINED_DO_NOT_CONTACT: 'The payment was declined by your bank.',
  TIMED_OUT: 'The payment timed out. Please try again.',
  ACQUIRER_SYSTEM_ERROR: 'The payment could not be processed. Please try again.',
  UNSPECIFIED_FAILURE: 'The payment could not be processed. Please try again.'
};

const GENERIC = 'The payment could not be processed. Please try again.';

// Returns a translation key, or null when there is no error to show.
// If the backend already sent friendly text (no ALL_CAPS code in it),
// it is passed through unchanged.
export const paymentFailureReason = (gatewayError) => {
  if (!gatewayError || !String(gatewayError).trim()) return null;
  const match = String(gatewayError).match(/[A-Z][A-Z_]{2,}/);
  if (!match) return String(gatewayError).trim();
  return REASONS[match[0]] || GENERIC;
};
